// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.common-gray-card {
  padding: 25px;
  border-radius: 5px;
  background-color: #f1f4f7;
  margin-bottom: 15px;
}
.common-gray-card.border {
  border: 1px solid gray;
}
.common-gray-card.more-white {
  background-color: #fafafa !important;
}
.common-gray-card.more-blue {
  background-color: #f8f8ff !important;
}
.common-gray-card.more-red {
  background-color: #f7f0f0 !important;
}
.common-gray-card.more-yellow {
  background-color: #fffff3 !important;
}
.common-gray-card.bright-orange {
  background-color: #efa207 !important;
}
.common-gray-card.more-dark {
  background-color: #e6e6e6 !important;
}
@media (max-width: 1440px) and (min-width: 481px) {
  .common-gray-card {
    padding: 20px;
  }
}
@media (max-width: 480px) {
  .common-gray-card {
    padding: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Commons/GrayCard/grayCard.scss","webpack://./src/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AADJ;AAEI;EACI,sBAAA;AAAR;AAEI;EACI,oCAAA;AAAR;AAEI;EACI,oCAAA;AAAR;AAEI;EACI,oCAAA;AAAR;AAEI;EACI,oCAAA;AAAR;AAEI;EACI,oCAAA;AAAR;AAEI;EACI,oCAAA;AAAR;ACpBI;EDJJ;IA2BQ,aAAA;EACN;AACF;AC9BI;EDCJ;IA8BQ,aAAA;EAGN;AACF","sourcesContent":["@import \"styles/mixins\";\n@import \"styles/variables\";\n.common-gray-card {\n    padding: 25px;\n    border-radius: 5px;\n    background-color: #f1f4f7;\n    margin-bottom: 15px;\n    &.border {\n        border: 1px solid gray;\n    }\n    &.more-white {\n        background-color: $light-white !important;\n    }\n    &.more-blue {\n        background-color: #f8f8ff !important;\n    }\n    &.more-red {\n        background-color: #f7f0f0 !important;\n    }\n    &.more-yellow {\n        background-color: #fffff3 !important;\n    }\n    &.bright-orange {\n        background-color: #efa207 !important;\n    }\n    &.more-dark {\n        background-color: #e6e6e6 !important;\n    }\n    @include Tablet() {\n        padding: 20px;\n    }\n    @include Mobile() {\n        padding: 15px;\n    }\n}\n","@mixin Mobile() {\n    @media (max-width: 480px) {\n        @content;\n    }\n}\n@mixin Tablet() {\n    @media (max-width: 1440px) and (min-width: 481px) {\n        @content;\n    }\n}\n@mixin TabletAndPC() {\n    @media (min-width: 481px) {\n        @content;\n    }\n}\n@mixin TabletVertical() {\n    @media (max-width: 768px) and (orientation: portrait) {\n        @content;\n    }\n}\n@mixin TabletHorizontal() {\n    @media (max-width: 768px) and (orientation: landscape) {\n        @content;\n    }\n}\n@mixin PC() {\n    @media (min-width: 769px) {\n        @content;\n    }\n}\n@mixin LowHeight() {\n    @media (max-height: 700px) {\n        @content;\n    }\n}\n@mixin LowHeightVertical() {\n    @media (max-height: 700px) and (min-width: 769px) {\n        @content;\n    }\n}\n@mixin HighHeight() {\n    @media (min-height: 701px) {\n        @content;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
